/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-asset-modal .global-value-toggle{margin-bottom:1em}.ui-asset-modal ui-robot-value-editor{display:block;margin-top:2em}.ui-asset-modal .single-value-editor{position:relative}.ui-asset-modal .single-value-editor .global-value-hint{position:absolute;top:calc(100% - 2em);font-size:75%;display:block}"];
export { styles as styles };
